// Custom Components Library
// Mimics JDS Design System with full customization

// ===== CUSTOM COMPONENTS (Fully Custom) =====
export { default as Text } from "./Text";
export { default as Button, ActionButton } from "./Button";
export { default as Avatar, AvatarV2 } from "./Avatar";
export { default as Divider } from "./Divider";
export { default as Spinner } from "./Spinner";
export { default as Icon } from "./Icon";
export { default as Breadcrumbs } from "./Breadcrumbs";

// Export individual icon components for direct import
export {
  IcHome,
  IcNotification,
  IcSearch,
  IcPerson,
  IcBusinessman,
  IcMail,
  IcPhone,
  IcWhatsapp,
  IcBuilding,
  IcGroup,
  IcSettings,
  IcDocument,
  IcCode,
  IcTicketDetails,
  IcEditPen,
  IcTrash,
  IcClose,
  IcAdd,
  IcUpload,
  IcChevronLeft,
  IcChevronRight,
  IcChevronUp,
  IcChevronDown,
  IcSuccess,
  IcError,
  IcWarning,
  IcSort,
  IcSwap,
  IcCookies,
  IcJioDot,
  IcCalendar,
  IcCalendarWeek,
  IcTime,
  IcTimelapse,
  IcSmartSwitchPlug,
  IcAttachment,
  IcDocumentViewer,
  IcNotes,
  IcAlarmOff,
  IcAlignBottom,
  IcStatusSuccessful,
  IcQrCode,
  IcFavorite,
  Ic404Error,
  ic_search,
  IcRequest,
  IcVisible,
  IcInvisible,
  IcSuccessColored,
  IcErrorColored,
  IcWarningColored,
  IcFilter,
  IcDownload,
  IcRefresh,
  IcUpdate,
  IcKeyboard,
  IcLanguage,
  IcStamp,
  IcVoice,
  IcVoiceRecording,
  IcRechargeNow,
  IcSubscriptions,
  IcStatusFail,
  IcInfo,
  IcTimezone,
  IcTeam,
  IcForms,
  IcSms,
  IcNetwork,
  IcEngineeringRequest,
  IcPageSettings,
  IcLayout,
  IcEdit,
  IcBack,
  IcArrowDown,
  IcArrowUp,
  IcMinus,
  IcProfile,
  ic_back,
  ic_close,
  ic_add,
  ic_minus,
  ic_chevron_down,
  ic_profile,
  ic_jio_dot,
  IcDatabase,
  IcSnake,
  IcPlan,
  IcFlipVertical,
  IcDownloads,
  IcAlarmSensor,
  IcDataLoan,
} from "./Icon";

// ===== ALL CUSTOM COMPONENTS (No JDS Dependencies) =====
export { default as InputFieldV2 } from "./InputFieldV2";
export { default as InputField } from "./InputField";
export { default as InputCode } from "./InputCode";
export { default as InputCheckbox } from "./InputCheckbox";
export { default as InputDropdown } from "./InputDropdown";
export { default as InputToggle } from "./InputToggle";
export { default as InputRadio } from "./InputRadio";
export { default as Modal } from "./Modal";
export { default as Card } from "./Card";
export { default as Tabs } from "./Tabs";
export { default as TabItem } from "./TabItem";
export { default as BadgeV2 } from "./BadgeV2";
export { default as SearchBox } from "./SearchBox";
export { default as Image } from "./Image";
export { default as Skeleton } from "./Skeleton";
export { default as TokenProvider } from "./TokenProvider";
export { default as Notifications } from "./Notifications";
export { default as Footer } from "./Footer";

